import React, { useEffect } from "react";
import styled from "styled-components";
import {
  Page,
  HeroWrap,
  Label,
  Headline,
  SubtitleRow,
  ResultsSection
} from "../components/CaseStudyLayout";

const VideoContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 40px auto 80px;
  background: var(--panel-bg);
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(150, 150, 150, 0.1);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
`;

const Renovations = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Page>
      <HeroWrap>
        <Label>DANCE FILM — MOVEMENT DIRECTION</Label>
        <Headline>Renovations</Headline>
        <SubtitleRow>
          <p>
            A man examines his past. Confronted with the fact that he, his talents, and his relationships have all changed, he searches for a way to navigate the future. It's never that simple, but you'd better get to work.
          </p>
          <div className="meta">
            <strong>ROLE</strong>
            <span>Director, Choreographer, Lead Actor & Producer</span>
            <strong>SECTOR</strong>
            <span>Independent Film</span>
          </div>
        </SubtitleRow>
      </HeroWrap>

      <VideoContainer>
        <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
          <iframe
            src="https://player.vimeo.com/video/647894928?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", borderRadius: "8px" }}
            title="renovations"
          ></iframe>
        </div>
      </VideoContainer>

      <ResultsSection>
        <div className="left">
          <h2>About the Film</h2>
          <p>
            Renovations is a short dance film exploring themes of change, memory, and personal evolution. 
            The movement direction focuses on expressing emotional resistance and physical adaptation, translating the internal psychological struggle of rebuilding one's life into physical motion.
          </p>
        </div>
        <div className="metrics-grid">
          <div className="result-stat">
            <h3>Vimeo</h3>
            <h4>Featured Film</h4>
            <p>High-fidelity video playback</p>
          </div>
        </div>
      </ResultsSection>
    </Page>
  );
};

export default Renovations;
